import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';



import { Router, ActivatedRoute } from '@angular/router';


import { ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { Configuration } from '../../conf/app.constants';

import { HelpService } from '../../components/common/help/help.service';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { InterfaceSettings } from '../../api/contract-notice-dto';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { forkJoin, ObservableInput } from 'rxjs';

import { formElementComponent } from '../../components/forms/formElement.component';
import { BudgetaryProjectDTO, IncomeBreakdownDTO, CostBreakdownDTO, BugdetaryBreakdownDTO } from '../../api/sarga-dtos';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';


export class BudgetaryProjectModel {
  dto: BudgetaryProjectDTO;
  ui: {
    isContextWork?: boolean,
    annuitiesList?: any[],
    incomeConcepts?: any[],
    costConcepts?: any[],
    costBreakdownList?: any[],
    incomeBreakdownList?: any[],
    totalBreakdownList?: any[],
    budgetaryProjectDTO?: BudgetaryProjectDTO,
    selectedIncomeBreakDown?: IncomeBreakdownDTO[]
    selectedCostBreakDown?: CostBreakdownDTO[]
  }
}

@Component({
  selector: 'budgetaryProject-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})

export class BudgetaryProjectsComponent
  extends BaseFormComponent<BudgetaryProjectDTO, BudgetaryProjectModel>
  implements OnInit, OnDestroy, AfterContentInit {
  headerService: any;
  private identifier: string;
  annuitiesList = [];
  incomeConcepts = [];
  costConcepts = [];
  costBreakdownList = [];
  incomeBreakdownList = [];
  totalBreakdownList = [];

  masterDataMeses: any;


  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,

    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService
  ) {
    super(elem);
    this.waitService.startWaiting();

    this.waitService.cancelWaiting();

    this.subscribe(this.activatedRoute.params
      .pipe(tap(params => (this.identifier = params['id'])))
    );

  }



  ngAfterContentInit(): void {

  }

  getFormSettingURL(): string {
    return 'budgetaryProjects/budgetaryProjectInterfaceSettings.json';
  }


  close() { }

  dtoToModel(dto: BudgetaryProjectDTO): Observable<BudgetaryProjectModel> {
    let model = new BudgetaryProjectModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    }

    this.setAnnuities(dto, model);
    this.setConceptsList(dto, model);

    let modelObs: Observable<BudgetaryProjectModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: BudgetaryProjectModel): BudgetaryProjectDTO {
    if (model.dto.budgetaryBreakDownList !== undefined) {
      model.dto.budgetaryBreakDownList.forEach(bugdetaryBreakdown => {
        if (bugdetaryBreakdown.incomeBreakdownList !== undefined) {
          bugdetaryBreakdown.incomeBreakdownList.forEach(incomeBreakdown => {
            incomeBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        if (bugdetaryBreakdown.costBreakdownList !== undefined) {
          bugdetaryBreakdown.costBreakdownList.forEach(costBreakdown => {
            costBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        if (bugdetaryBreakdown.totalBreakdownList !== undefined) {
          bugdetaryBreakdown.totalBreakdownList.forEach(totalBreakdown => {
            totalBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        this.addGrossMargin(model);
      });
    }
    if (this.task) {
      this.task.work.budgetaryProject = model.dto;

    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Expediente Presupuestario';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task) {
      console.log('INVOCACION DE BUDGETARYPROJECT DESDE TAREA', this.task);
      //this.model.dto = this.task.work.budgetaryProject;
      identifier = this.task.work.budgetaryProject.identifier;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }

  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'budgetaryProject/';

  }

  initHeaderActions() {
    this.subscribe(this.headerActionsService
      .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
      , (() => {
        this.validateBudgetaryProject();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          if (this.task !== undefined) {
            this.cleanWorkBudgetaryProject();
            this.subscribe(this.saveIfValid());
          } else {
            this.subscribe(this.validate(false),
              result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                  this.uiService.showConfirmMessage({
                    message: 'Se han detectado errores que impiden la tramitación. ¿Desea guardar el expediente?',
                    header: 'Confirmacion',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {

                      console.log('Grabando expediente...');
                      this.subscribe(this.save(true), _model => {

                        if (_model) {
                          this.goToDossierInfo(_model);
                        } else {
                          this.goToDossierInfo(this.model.dto);
                        }
                      },
                        error => {
                          this.plycaErrorHandler.showServerError(error);
                        });

                    },
                    reject: () => {
                      this.waitService.cancelWaiting();
                      console.log('No hace nada...');
                    }

                  });
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.save(),
                    _model => {
                      this.waitService.cancelWaiting();
                      if (_model) {
                        this.showConfirmMessage(_model);
                      } else {
                        this.showConfirmMessage(this.model.dto);
                      }
                    });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
            )

          }
        }));
    this.headerActionsService.addDivider();
    this.addBack();
  }

  showConfirmMessage(_budgetaryProject: BudgetaryProjectDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.plycaService.startProject(_budgetaryProject, this.getServiceURL())
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          )
          .subscribe(() => {
            this.goToDossierInfo(_budgetaryProject);
          },
            () => {
              console.log('Error');
            }
          );
      },
      reject: () => {
        this.goToDossierInfo(_budgetaryProject);
        console.log('Saliendo...');
      }
    });
  }

  goToDossierInfo(_budgetaryProject: BudgetaryProjectDTO) {
    this.router.navigate(['dossierInfo/' + _budgetaryProject.identifier], {
    });
  }

  validateBudgetaryProject() {
    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.uiService.showMessage(
          'Se ha validado correctamente.',
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        if (this.task !== undefined) {
          this.cleanWorkBudgetaryProject();
        }
        this.salir();
      }));
  }

  private cleanWorkBudgetaryProject() {
    // this.waitService.startWaiting();

  }

  private setAnnuities(dto: BudgetaryProjectDTO, model: BudgetaryProjectModel): void {
    model.ui.annuitiesList = [];
    if (dto.annuitiesList !== undefined) {
      model.ui.annuitiesList = [];
      dto.annuitiesList.forEach(annuity => {
        model.ui.annuitiesList.push({
          'label': '' + annuity,
          'value': annuity
        });

      });
    }
  }

  // Inicializamos las listas de conceptos y meses.
  private setConceptsList(dto: BudgetaryProjectDTO, model: BudgetaryProjectModel): void {
    model.ui.incomeConcepts = dto.incomeConcepts;
    model.ui.costConcepts = dto.costConcepts;
    model.ui.incomeBreakdownList = dto.incomeBreakdownList;
    model.ui.costBreakdownList = dto.costBreakdownList;
    model.ui.totalBreakdownList = dto.totalBreakdownList;
  }


  // *********************************************//
  // MEZCLA DE FORMULARIOS: PRINCIPAL + DESGLOSE //
  // *********************************************//
  createFormConfig(): Observable<FormConfig> {

    let baseFormURL = this.getFormSettingURL();
    let budgetaryProjectForm: Observable<InterfaceSettings>;
    let budgetaryProjectFormURL = 'budgetaryProjects/budgetaryProjectInterfaceSettings.json';
    budgetaryProjectForm = this.plycaService.getInterfaceSettings(budgetaryProjectFormURL, true).pipe(
      catchError((e: any) => this.ignoreError(e, budgetaryProjectFormURL))
    );

    // Desglose Presupuesatario
    let budgetaryBreakdownFormURL = 'commonProjects/budgetaryBreakdownInterfaceSettings.json';
    let budgetaryBreakdownForm: Observable<InterfaceSettings>;

    budgetaryBreakdownForm = this.plycaService.getInterfaceSettings(budgetaryBreakdownFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, budgetaryBreakdownFormURL))
    );

    return forkJoin(
      this.plycaService.getInterfaceSettings(baseFormURL),
      budgetaryProjectForm, // 0
      budgetaryBreakdownForm// 1
    ).pipe(
      map((result: InterfaceSettings[]) => {
        let mergedInterfacceSettings = result[0];
        let interfaceToMerge = result[1];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        interfaceToMerge = result[2];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        let formConfig = this.newFormConfig();
        formConfig.interfaceSetting = mergedInterfacceSettings;
        formConfig.isModalWindow = false;
        formConfig.showValidations = true;
        return formConfig;
      }),
      finalize(() => { console.log('Creado') })
    );

  }


  private ignoreError(e: any, channeFormURL: string): ObservableInput<InterfaceSettings> {
    console.error('Error al obtener definicion del formulario ' + channeFormURL);
    return of(undefined);
  }

  private newFormConfig(): FormConfig {
    let formConfig: FormConfig;
    formConfig = new FormConfig('budgetaryProjects/budgetaryProjectInterfaceSettings.json', undefined, this.model);
    return formConfig;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
  }

  // *************************************************//
  // FIN MEZCLA DE FORMULARIOS: PRINCIPAL + DESGLOSE //
  // *************************************************//


  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');


    _formConfig.functions.push({
      identifier: 'addNewRecord',
      fn: this.addNewRecord
    });

    _formConfig.functions.push({
      identifier: 'addIncomeAmount',
      fn: this.addIncomeAmount
    });

    _formConfig.functions.push({
      identifier: 'addTotalIncomeAmount',
      fn: this.addTotalIncomeAmount
    });

    _formConfig.functions.push({
      identifier: 'addTotalProductionAmount',
      fn: this.addTotalProductionAmount
    });

    _formConfig.functions.push({
      identifier: 'addTotalCostAmount',
      fn: this.addTotalCostAmount
    });

    _formConfig.functions.push({
      identifier: 'addTotalAmount',
      fn: this.addTotalAmount
    });

    _formConfig.functions.push({
      identifier: 'clearDeptarmentData',
      fn: this.clearDeptarmentData
    });

    _formConfig.functions.push({
      identifier: 'clearAreaData',
      fn: this.clearAreaData
    });

    _formConfig.functions.push({
      identifier: 'addGrossMargin',
      fn: this.addGrossMargin
    });

    _formConfig.functions.push({
      identifier: 'updateModificationDate',
      fn: this.updateModificationDate
    });

  }


  addNewRecord() {

    let _this = this as unknown as formElementComponent;
    let bugdetaryBreakdownDTO = new BugdetaryBreakdownDTO;
    let today = new Date();
    bugdetaryBreakdownDTO.creationDate = today;
    if (!this.model.dto.budgetaryBreakDownList || this.model.dto.budgetaryBreakDownList.length === 0) {
      this.model.dto.budgetaryBreakDownList = [];
      bugdetaryBreakdownDTO.year = today.getFullYear();
    }
    bugdetaryBreakdownDTO.modificationDate = today;
    bugdetaryBreakdownDTO.costBreakdownList = [];
    bugdetaryBreakdownDTO.incomeBreakdownList = [];
    bugdetaryBreakdownDTO.totalBreakdownList = [];
    bugdetaryBreakdownDTO.incomeBreakdownList = this.model.dto.incomeBreakdownList;
    bugdetaryBreakdownDTO.costBreakdownList = this.model.dto.costBreakdownList;
    bugdetaryBreakdownDTO.totalBreakdownList = this.model.dto.totalBreakdownList;

    this.model.dto.budgetaryBreakDownList.push(bugdetaryBreakdownDTO);

    _this.editRow(bugdetaryBreakdownDTO);
  }

  updateModificationDate(model: any) {
    let today = new Date();
    if (model !== undefined && model.modificationDate !== undefined) {
      model.modificationDate = today;
    }
    return true;
  }

  addIncomeAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.amountMonths !== undefined) {
      model.amountMonths.forEach(element => {
        if (element.amount !== undefined) {
          if (totalAmount !== 0) {
            totalAmount = totalAmount + element.amount;
          } else {
            totalAmount = element.amount;
          }
        }
      });
      model.totalAmount = totalAmount;
    }
    return totalAmount;
  }

  // Calculado: Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
  addTotalIncomeAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.incomeBreakdownList !== undefined) {
      model.incomeBreakdownList.forEach(incomeBreakDown => {
        if (incomeBreakDown.incomeConcept !== undefined && incomeBreakDown.amount != undefined && incomeBreakDown.amountMonths !== undefined) {
          if (incomeBreakDown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' || incomeBreakDown.incomeConcept.identifier === '2<>SARGA_CONCEPTO_INGRESO') {
            incomeBreakDown.amountMonths.forEach(incomeMonth => {
              if (incomeMonth.amount !== undefined) {
                totalAmount = totalAmount + incomeMonth.amount;
              }
            });
          }
        }
      });
    }
    return totalAmount;
  }

  // Calculado: Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
  addTotalProductionAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.incomeBreakdownList !== undefined) {
      model.incomeBreakdownList.forEach(incomeBreakDown => {
        if (incomeBreakDown.incomeConcept !== undefined && incomeBreakDown.amountMonths !== undefined) {
          if (incomeBreakDown.incomeConcept.identifier === '4<>SARGA_CONCEPTO_INGRESO' || incomeBreakDown.incomeConcept.identifier === '5<>SARGA_CONCEPTO_INGRESO') {
            incomeBreakDown.amountMonths.forEach(incomeMonth => {
              if (incomeMonth.amount !== undefined) {
                totalAmount = totalAmount + incomeMonth.amount;
              }
            });
          }
        }
      });
    }
    return totalAmount;
  }

  addGrossMargin(model: any) {
    let totalAmount = 0;
    let totalIncome = 0;
    let totalCost = 0;
    if (model.dto.budgetaryBreakDownList !== undefined) {
      model.dto.budgetaryBreakDownList.forEach(bugdetaryBreakdown => {
        if (bugdetaryBreakdown !== undefined) {
          if (bugdetaryBreakdown.totalIncome !== undefined) {
            totalIncome = bugdetaryBreakdown.totalIncome;
          }
          if (bugdetaryBreakdown.totalCost !== undefined) {
            totalCost = bugdetaryBreakdown.totalCost;
          }
          if (totalIncome !== undefined && totalCost !== undefined && totalIncome > 0) {
            totalAmount = ((totalIncome + totalCost) / totalIncome) * 100;
            bugdetaryBreakdown.grossMargin = totalAmount;
          }
        }
      });
    }
  }

  // Suma todos los costes.
  addTotalCostAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.costBreakdownList !== undefined) {
      model.costBreakdownList.forEach(costBreakDown => {
        if (costBreakDown.costConcept !== undefined && costBreakDown.amountMonths !== undefined) {
          costBreakDown.amountMonths.forEach(costMonth => {
            if (costMonth.amount !== undefined) {
              totalAmount = totalAmount + costMonth.amount;
            }
          });
        }
      });
    }
    return totalAmount;
  }

  addTotalAmount(model: any) {
    let totalAmount = 0;
    //Si la accion es CANCELAR (por ejemplo escape, o aspa), al cerrar el desglsoe de meses.
    if (model._parent == undefined) {
      model._parent = this.model;
    }
    //Si la accion es ACEPTAR, al cerrar el desglsoe de meses.
    if (model !== undefined && model.totalConcept !== undefined) {
      //TOTAL INGRESOS: Dato autocalculado por cada mes del año. Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
      if (model.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES') {
        //TOTAL DEL COSTE!
        totalAmount = 0;
        //Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined && incomeBreakdown.amount !== undefined) {
              if (incomeBreakdown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' ||
                incomeBreakdown.incomeConcept.identifier === '2<>SARGA_CONCEPTO_INGRESO') {
                totalAmount = totalAmount + incomeBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (incomeBreakdown.amountMonths !== undefined) {
                  //Bucle para recorrer los meses del coste
                  incomeBreakdown.amountMonths.forEach(incomeMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === incomeMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + incomeMonth.amount;
                            totalMonthElement.month = incomeMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
          //return totalAmount;
        }
      }
      //TOTAL PRODUCCION: Dato autocalculado por cada mes del año. Sumatorio de los datos PRODUCCIÓN PREVISTA + PRODUCCIÓN PENDIENTE
      else if (model.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES') {
        //TOTAL DEL COSTE!
        totalAmount = 0;
        //Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined && incomeBreakdown.amount !== undefined) {
              if (incomeBreakdown.incomeConcept.identifier === '4<>SARGA_CONCEPTO_INGRESO' ||
                incomeBreakdown.incomeConcept.identifier === '5<>SARGA_CONCEPTO_INGRESO') {
                totalAmount = totalAmount + incomeBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (incomeBreakdown.amountMonths !== undefined) {
                  //Bucle para recorrer los meses del coste
                  incomeBreakdown.amountMonths.forEach(incomeMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === incomeMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + incomeMonth.amount;
                            totalMonthElement.month = incomeMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
          //return totalAmount;
        }
      }
      //TOTAL COSTES PERSONAL: Sumatorio de los datos GASTOS DE PERSONAL + DIETAS Y GASTOS Y ATENCIONES + FORMACIÓN Y OTROS GASTOS SOCIALES
      else if (model.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        //Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '16<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '17<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '18<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  //Bucle para recorrer los meses del coste
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
          //return totalAmount;
        }

      }
      //TOTAL COMPRAS: Sumatorio de los datos COMPRAS
      else if (model.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES') {
        // devuelve el total del concepto de costes: COMPRAR
        totalAmount = 0;
        //Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '1<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                //Fin desglose del total por meses
              }
            }
          });
          //return totalAmount;
        }
      }
      //TOTAL TRABAJOS REALIZADOS POR OTRAS EMPRESAS: Sumatorio de los datos TRABAJOS REALIZADOS POR OTRAS EMPRESAS EXTERNAS
      else if (model.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES') {
        // devuelve el total del concepto de costes: TRABAJOS REALIZADOS POR OTRAS EMPRESAS EXTERNAS (B)
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '2<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                //Fin desglose del total por meses
              }
            }
          });
          //return totalAmount;
        }
      }
      //TRABAJOS REALIZADOS POR PERSONAL EMPRESA EXTERNO AL DTO: Sumatorio de los datos TRABAJOS REALIZADOS POR OTRAS DEPARTAMENTOS FRAS INTERNAS
      else if (model.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '3<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                //Fin desglose del total por meses
              }
            }
          });
          //return totalAmount;
        }
      }
      //TOTAL OTROS COSTES: Sumatorio de los datos ALQUILERES I/G (suministros, oficinas, ...) ALQUILERES SOPORTADOS (suministros, oficinas, ...),
      // VEHÍCULOS SOPORTADOS (gasolina, alquiler, parking, ...), REPARACIONES Y CONSERVACIÓN, SERVICIOS PROFESIONALES, PRIMAS DE SEGUROS,GASTOS FINANCIEROS
      //PUBLICIDAD, SUMINISTROS I/G (teléfono, luz, agua, ...), SUMINISTROS SOPORTADOS (teléfono, luz, agua, ...), OTROS SERVICIOS, TRIBUTOS ,DOTACIÓN A LA AMORTIZACIÓN
      else if (model.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '4<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '5<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '6<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '7<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '8<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '9<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '10<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '11<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '12<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '13<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '14<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '15<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '19<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                //Fin desglose del total por meses
              }
            }
          });
          //return totalAmount;
        }
      }
      //TOTAL COSTES: SUMATORIO DE TODOS LOS ANTERIORES, (SIN LOS INGRESOS)
      else if (model.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '1<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '2<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '3<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '4<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '5<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '6<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '7<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '8<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '9<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '10<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '11<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '12<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '13<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '14<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '15<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '16<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '17<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '18<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '19<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                //HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                //Fin desglose del total por meses
              }
            }
          });
          //return totalAmount;
        }
      }
      //MARGEN PRESUPUESTADO BRUTO (INCLUIDO 5,5%): (TOTAL INGRESOS + TOTAL COSTES) / (TOTAL INGRESOS * 100)
      else if (model.totalConcept.identifier === '9<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '9<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        let totalIncome = 0;
        let totalIncomePerMont = [];
        let totalCost = 0;
        let totalCostPerMont = [];
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalIncome = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalIncomePerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalCost = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalCostPerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        // CAMPO TOTAL MOSTRADO EN LA TABLA. Hay que desglosarlo. return (TOTAL INGRESOS+TOTAL COSTES)/(TOTAL INGRESOS)*100 (%)


        if (totalIncomePerMont !== undefined && totalCostPerMont !== undefined) {
          totalIncomePerMont.forEach(elementIncome => {
            totalCostPerMont.forEach(elementCost => {

              if (elementIncome.month.identifier === elementCost.month.identifier) {
                let incomeCost = elementIncome.amount;
                let costCost = elementCost.amount;
                let month = elementIncome.month;
                model.amountMonths.forEach(element => {
                  if (element.month.identifier === month.identifier) {
                    element.month = month;
                    if (incomeCost != 0) {
                      element.amount = ((incomeCost - costCost) / costCost) * 100;
                    } else {
                      element.amount = 0.0;
                    }
                  }
                });
              }
            });
          });
        };

        if (totalIncome !== 0.0) {
          totalAmount = ((totalIncome - totalCost) / totalCost) * 100;
        } else {
          totalAmount = 0.0;
        }
        //return totalAmount;
      } else if (model.totalConcept.identifier === '10<>SARGA_CONCEPTO_TOTALES') {
        //MARGEN PRESUPUESTADO NETO SIN 5%: (TOTAL INGRESOS SIN 5% + TOTAL COSTES) / (TOTAL INGRESOS * 100)
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '10<>SARGA_CONCEPTO_TOTALES')
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
        });
        let totalIncomeWithoutPercent = 0;
        let totalIncomePerMontWithoutPercent = [];
        let totalCost = 0;
        let totalCostPerMont = [];
        let totalIncome = 0;
        let totalIncomePerMont = [];

        //TOTAL INGRESOS (del listado de totales)
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalIncome = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalIncomePerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }

        //TOTAL INGRESOS SIN 5% (del listado de ingresos)
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined &&
              incomeBreakdown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' && incomeBreakdown.amount !== undefined) {
              totalIncomeWithoutPercent = incomeBreakdown.amount;
              if (incomeBreakdown.amountMonths !== undefined) {
                totalIncomePerMontWithoutPercent = incomeBreakdown.amountMonths;
              }
            }
          });
        }

        //TOTAL COSTES
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalCost = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalCostPerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        // CAMPO TOTAL MOSTRADO EN LA TABLA. Hay que desglosarlo. return (TOTAL INGRESOS+TOTAL COSTES)/(TOTAL INGRESOS)*100 (%)


        if (totalIncomePerMontWithoutPercent !== undefined && totalCostPerMont !== undefined) {
          totalIncomePerMontWithoutPercent.forEach(elementIncomeWithoutPercent => {
            totalCostPerMont.forEach(elementCost => {
              if (elementIncomeWithoutPercent.month.identifier === elementCost.month.identifier) {
                totalIncomePerMont.forEach(elementIncome => {
                  if (elementIncome.month.identifier === elementCost.month.identifier) {
                    let incomeCostWithoutPercent = elementIncomeWithoutPercent.amount;
                    let incomeCost = elementIncome.amount;
                    let costCost = elementCost.amount;
                    let month = elementIncomeWithoutPercent.month;
                    model.amountMonths.forEach(element => {
                      if (element.month.identifier === month.identifier) {
                        element.month = month;
                        if (incomeCost != 0.0) {
                          element.amount = ((incomeCostWithoutPercent - costCost) / costCost) * 100;
                        } else {
                          element.amount = 0.0;
                        }
                      }
                    });
                  }
                });
              }
            });
          });
        };

        if (totalIncome !== 0) {
          totalAmount = ((totalIncomeWithoutPercent - totalCost) / totalCost) * 100;
        } else {
          totalAmount = 0.0;
        }
        //return totalAmount;
      }
    }
    return totalAmount;
  }


  clearDeptarmentData(model: any) {
    if (model.dto.organizationalUnit === undefined) {
      model.dto.area = undefined;
      model.dto.activity = undefined;
    } else if (model.dto.area !== undefined) {
      if (model.dto.area.unitParent.identifier !== model.dto.organizationalUnit.identifier) {
        model.dto.area = undefined;
        model.dto.activity = undefined;
      }
    }
  }

  clearAreaData(model: any) {
    if (model.dto.area === undefined) {
      model.dto.activity = undefined;
    } else {
      if (model.dto.area.identifier !== undefined && model.dto.activity !== undefined
        && model.dto.activity.properties !== undefined && model.dto.activity.properties.ORGANISMOHEX !== undefined) {
        if (model.dto.activity.properties.ORGANISMOHEX !== model.dto.area.identifier) {
          model.dto.activity = undefined;
        }
      }
    }
  }


  /*enabledIncome(model: any) {
    let result = true;
    if (model.incomeConcept.identifier === '3<>SARGA_CONCEPTO_INGRESO' || model.incomeConcept.identifier === '6<>SARGA_CONCEPTO_INGRESO') {
      result = false;
    }
    return result;
  }*/



  // Total Costes Personales: Sumatorio de GASTOS DE PERSONAL + DIETAS Y GASTOS Y ATENCIONES + DIETAS Y GASTOS Y ATENCIONES
  /*setTotalPersonalCost(model: any) {
    let totalAmount = 0;
    if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
      model._parent.costBreakdownList.forEach(costBreakdown => {
        if (costBreakdown.costConcept != undefined && costBreakdown.amount !== undefined) {
          if (costBreakdown.costConcept.identifier == '16<>SARGA_CONCEPTO_COSTES' ||
            costBreakdown.costConcept.identifier == '17<>SARGA_CONCEPTO_COSTES' ||
            costBreakdown.costConcept.identifier == '18<>SARGA_CONCEPTO_COSTES') {
            totalAmount = totalAmount + costBreakdown.amount;
          }
        }
      });
    }
    return totalAmount;
  }*/









}
